/**
 * Toast display durations (ms).
 * Use when dispatching openGlobalToast to control how long the toast stays visible.
 */

/** Short duration – quick feedback (e.g. delete success, download). 2s */
export const kToastDurationShortMs = 2000

/** Medium duration – context switch or copy confirmations (e.g. matter switch, link copied). 3s */
export const kToastDurationMediumMs = 3000

/** Long duration – errors or messages that need more reading time (e.g. validation errors). 5s */
export const kToastDurationLongMs = 5000

/** Default duration – when no duration is passed to openGlobalToast. 10s */
export const kToastDurationDefaultMs = 10000
